const model = {
    id: '',
    traffickingType: 'sex',
    conclusion: '',
    comments: '',
    fileName: '',
    person: ''
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/oldTraffickingScreening.js